import React, {Component} from 'react';
import {translate} from 'react-i18next';
import PropTypes from 'prop-types';
import DealCompositionView from './DealCompositionView';
import * as _ from 'lodash';
import {getFormatPrice, calcCostDeal} from '../../helpers'

class DealCustomizeView extends Component {
  constructor(props) {
    super(props);

    this.expandedComposition = this.expandedComposition.bind(this);
    this.isCompositionExpanded = this.isCompositionExpanded.bind(this);
    this.closeComposition = this.closeComposition.bind(this);
    this.addToCard = this.addToCard.bind(this);
    this.getSelectedProduct = this.getSelectedProduct.bind(this);
    this.canUpdateBasket = this.canUpdateBasket.bind(this);
    this.updateBasket = this.updateBasket.bind(this);

    this.state = {
      openedCompositionId: undefined,
      selectedProducts: props.userData || [],
    };
  }

  expandedComposition(id) {
    this.setState({
      openedCompositionId: id,
    });
  }

  isCompositionExpanded(id) {
    return this.state.openedCompositionId === id;
  }

  closeComposition() {
    this.setState({
      openedCompositionId: null,
    });
  }

  addToCard(composition, data) {
    const {selectedProducts} = this.state;
    const index = _.findIndex(selectedProducts, {id: composition.id});
    const result = {
      id: composition.id,
      type: composition.type,
      data: data,
    };
    if (index !== -1) {
      selectedProducts[index] = result;
    } else {
      selectedProducts.push(result);
    }

    this.setState({
      selectedProducts: selectedProducts,
    });
  }

  getSelectedProduct(composition) {
    const result = _.find(this.state.selectedProducts, {id: composition.id});

    return result || {};
  }

  canUpdateBasket() {
    return Object.keys(this.state.selectedProducts).length === this.props.deal.compositions.length;
  }

  updateBasket() {
    this.props.addToBasket(this.state.selectedProducts);
  }

  render() {
    const {deal, t, language, onClose, restaurant} = this.props;
    return (
      <div className="app__wrapper">
        <div className="deals">
          <div className="deals__heading">
            <div className="deals-header">
              <div className="deals-header__title">
                <button className="return-button deals-header__link" onClick={onClose}>{t('back')}</button>
                <h4>{deal[`name_${language}`]}</h4>
              </div>
              <div className="deals-header__image">
                <img src={deal.photo} alt={deal[`name_${language}`]}/>
              </div>
              <div className="deals-header__description">
                {deal[`description_${language}`]}
                <div className="deals-header__price">€{getFormatPrice(calcCostDeal(deal))}</div>
              </div>
            </div>
          </div>
          <div className="deals__content">

            {/*Collapsed deals Item*/}
            {deal.compositions.map((composition, index) => (
              <DealCompositionView
                key={index}
                composition={composition}
                isSelected={this.isCompositionExpanded(composition.id)}
                onSelect={this.expandedComposition}
                onClose={this.closeComposition}
                language={language}
                restaurant={restaurant}
                selectedProduct={this.getSelectedProduct(composition).data}
                addToCard={this.addToCard}
              />
            ))}

            {/* TODO implement new add to card button!!!! */}
            {this.canUpdateBasket() && <div className="deals-item">
              <div className="deals-confirm">
                <button
                  className="deals-confirm__button" type="button"
                  onClick={this.updateBasket}
                  onTouchStart={this.updateBasket}
                  onTouchEnd={(e) => e.preventDefault()}
                >{t('updateBasket')}</button>
              </div>
            </div>}
          </div>
        </div>
      </div>
    );
  }
}

DealCustomizeView.propTypes = {
  userData: PropTypes.array,
  deal: PropTypes.object.isRequired,
  language: PropTypes.string,
  onClose: PropTypes.func,
  restaurant: PropTypes.object,
  addToBasket: PropTypes.func,
};

export default translate('translations')(DealCustomizeView);


// WEBPACK FOOTER //
// ./src/components/Deals/DealCustomizeView.js